import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalCloseButton, ModalTitle } from "@air/primitive-modal";
import { memo } from "react";
import { MODAL_LABEL, X_BUTTON } from "~/constants/testIDs";
export const ShareModalHeader = /*#__PURE__*/ memo((param)=>{
    let { onClose, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-4 flex items-center justify-between gap-4",
        children: [
            /*#__PURE__*/ _jsx(ModalTitle, {
                "data-testid": MODAL_LABEL,
                children: title
            }),
            /*#__PURE__*/ _jsx(ModalCloseButton, {
                className: "shrink-0",
                onClick: onClose,
                "data-testid": X_BUTTON
            })
        ]
    });
});
ShareModalHeader.displayName = "ShareModalHeader";
